<template>
  <div class="creative-title-wrap">
    <div v-if="adCount.length > 0">
      <div class="card-header">
        创意标题<span class="num-text">{{ dataList.length }}/50</span>
        <div class="btn-group">
          <el-button icon="el-icon-plus" type="text" @click="addTitle">新增</el-button>
          <span class="center-line"></span>
          <el-button @click="clearAllGroup" type="text" :disabled="adCount.length === 0">清空</el-button>
          <!-- <el-button icon="el-icon-plus" type="text" @click="selectTitle">选择已有</el-button> -->
        </div>
      </div>
      <div class="card-list">
        <card-item
          v-for="(item, index) of dataList"
          :key="item.itemId"
          :title="`创意标题${index + 1}`"
          :dataSet="item"
          @edit="editCreativeTitle"
          @copy="copyCreativeTitle"
          @del="delCreativeTitle"
          :isCur="curItem.itemId === item.itemId"
          :showDelete="dataList.length > 1"
        ></card-item>
      </div>
      <div class="add-modal-body" v-if="dataList.length > 0">
        <div class="modal-content">
          <el-form ref="titleFormRef" :model="curItem" :rules="rules" label-width="90px">
            <!-- <el-form-item label="标题：" prop="titles">
              <el-button @click="openWordModal('title')">文案助手</el-button>
              <div v-for="(item, index) in curItem.titles" :key="index" style="display: flex;width: 500px">
                <el-input :maxlength="12" show-word-limit v-model="curItem.titles[index]" placeholder="输入标题，1-14字"></el-input>
                <span @click="deleteTitle(index, 'title')" style="margin-left: 8px;cursor: pointer" v-if="curItem.titles.length > 1"
                  ><i class="el-icon-delete"></i
                ></span>
              </div>
              <span
                v-if="curItem.titles.length < 3 && isDynamicCreative"
                style="color: #0b75ff;cursor: pointer"
                @click="curItem.titles.push('')"
              >
                添加
              </span>
            </el-form-item> -->
            <el-form-item label="文案：" prop="descriptions">
              <el-button @click="openWordModal('descriptions')">文案助手</el-button>
              <div v-for="(item, index) in curItem.descriptions" :key="index" style="display: flex;width: 500px">
                <el-input
                  :maxlength="30"
                  :minlength="6"
                  show-word-limit
                  v-model="curItem.descriptions[index]"
                  placeholder="输入文案，6-30字"
                ></el-input>
                <span @click="deleteTitle(index, 'descriptions')" style="margin-left: 8px;cursor: pointer"
                  ><i class="el-icon-delete"></i
                ></span>
              </div>
              <span
                v-if="curItem.descriptions.length < 3 && isDynamicCreative"
                style="color: #0b75ff;cursor: pointer"
                @click="curItem.descriptions.push('')"
              >
                添加
              </span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-else class="empty-content">
        暂无数据
      </div>

      <!-- 动态词包 -->
      <el-dialog title="文案助手" :visible.sync="showWordModal" width="764px" :close-on-click-modal="false">
        <div class="word-modal-body">
          <div class="modal-content">
            <div style="display: flex">
              <div style="flex: 1">
                <el-cascader
                  style="width: 330px"
                  separator="  "
                  v-model="filterData.categoryType"
                  clearable
                  :options="wordTypeOptions"
                  :props="{ value: 'industryId', label: 'industryName' }"
                  @change="handleChangeWordType"
                ></el-cascader>
              </div>
              <el-input style="width: 200px" v-model="filterData.text" placeholder="输入搜索文字" @input="handleChangeWord"></el-input>
            </div>
            <div class="wordlist-wrap" v-loading="loading">
              <div class="header">标题</div>
              <div class="content">
                <el-checkbox-group v-model="selectValue" :max="isDynamicCreative ? 3 : 1">
                  <el-checkbox v-for="item in wordList" :label="item.text" :key="item.text">
                    <div class="text-item">
                      <span>{{ item.text }}</span
                      ><el-tag v-if="item.tag" style="margin-left: 12px" size="mini">{{ item.tag }}</el-tag>
                    </div>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="footer-wrap">
          <el-button @click="showWordModal = false">取 消</el-button>
          <el-button type="primary" @click="handleSaveWord" :disabled="selectValue.length < 1">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <div class="card-header">
        创意标题
      </div>
      <div class="empty-content">
        请先选账户
      </div>
    </div>
  </div>
</template>

<script>
import { getCreativeTextList } from "@/api/promotion-gdt.js";
import CardItem from "./common/cardItem.vue";
import { mapState } from "vuex";
import { wordTypeOptions } from "./common/config";
export default {
  components: {
    CardItem,
  },
  data() {
    return {
      showWordModal: false,
      dataList: [],
      wordList: [],
      loading: false,
      selectValue: [],
      filterData: {
        categoryType: ["21474836523", "21474840798"],
        text: "",
      },
      wordTypeOptions,
      curWordType: "", //当前编辑的类型
      curItem: {
        // titles: [""],
        descriptions: [""],
      },
      rules: {
        titles: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              value.map((item) => {
                if (!item.trim()) {
                  callback(new Error("标题为必填"));
                } else {
                  callback();
                }
              });
            },
          },
        ],
        descriptions: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              value.map((item) => {
                if (!item.trim()) {
                  callback(new Error("描述为必填"));
                } else if (item.trim().length < 6) {
                  callback(new Error("描述最少为6个字"));
                } else {
                  callback();
                }
              });
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.addTitle();
  },
  methods: {
    clearAllGroup() {
      this.dataList = [];
      this.saveInStore();
    },
    getTextList(data) {
      this.loading = true;
      getCreativeTextList({
        accountIds: this.advertiserIdList,
        categoryFirstLevel: this.filterData.categoryType[0],
        categorySecondLevel: this.filterData.categoryType[1],
        maxTextLength: this.curWordType === "title" ? 12 : 30,
        ...data,
      }).then((res) => {
        this.loading = false;
        this.wordList = res.data;
      });
    },
    addTitle() {
      if (this.dataList.length >= 50) {
        return;
      }
      this.dataList.push({
        itemId: Math.random(),
        // titles: [""],
        descriptions: [""],
      });
      if (this.dataList.length === 1) {
        this.curItem = this.dataList[0];
      }
      this.saveInStore();
    },
    openWordModal(type) {
      this.selectValue = [];
      this.curWordType = type;
      this.getTextList();
      this.showWordModal = true;
    },
    deleteTitle(index, type) {
      if (type === "title") {
        this.curItem.titles.splice(index, 1);
      } else {
        this.curItem.descriptions.splice(index, 1);
      }
    },
    handleSaveWord() {
      this.showWordModal = false;
      if (this.curWordType === "title") {
        this.curItem.titles = this.selectValue;
      } else {
        this.curItem.descriptions = this.selectValue;
      }
    },
    handleChangeWordType() {
      this.getTextList();
    },
    handleChangeWord() {
      this.getTextList({ keyWord: this.filterData.text });
    },
    insertData() {
      this.showWordModal = false;
      this.$refs.titleFormRef.validate(() => {});
    },
    saveInStore() {
      this.$store.commit("set_draft_creative_title_gdt", this.dataList);
    },
    editCreativeTitle(item) {
      this.curItem = item;
    },
    copyCreativeTitle(item) {
      if (this.dataList.length >= 50) {
        return;
      }
      let copyData = JSON.parse(JSON.stringify(item));
      copyData.itemId = Math.random();
      this.dataList.push(copyData);
      this.saveInStore();
    },
    delCreativeTitle(delItem) {
      let delIndex = this.dataList.findIndex((item) => item.itemId === delItem.itemId);
      this.dataList.splice(delIndex, 1);
      this.saveInStore();
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 0) {
          for (let i = 0; i < this.dataList.length; i++) {
            this.$refs.titleFormRef.validate((valid) => {
              if (valid) {
                this.saveInStore();
                resolve();
              } else {
                this.editCreativeTitle(this.dataList[i]);
                reject();
              }
            });
          }
        } else {
          reject();
        }
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount || [],
      advertiserIdList: (state) => state.PromotionGdt.advertiserIdList,
      isDynamicCreative: (state) => state.PromotionGdt.draft_adset.isDynamicCreative,
      originTextGroups: (state) => state.PromotionGdt.origin_draft_creative.textGroups,
    }),
  },
  watch: {
    isDynamicCreative: {
      handler() {
        // this.curItem.titles = [""];
        this.curItem.descriptions = [""];
      },
    },
    originTextGroups: {
      handler(value) {
        if (value) {
          const storeData = JSON.parse(JSON.stringify(value));
          this.dataList = storeData;
          //聚焦最后一个
          if (this.dataList.length > 0) {
            this.editCreativeTitle(this.dataList[this.dataList.length - 1]);
          }
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.creative-title-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
  }
  .empty-content {
    height: 200px;
    font-size: 20px;
    margin-left: 10px;
    color: #818181;
    text-align: center;
    line-height: 200px;
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }
  .word-modal-body {
    .modal-content {
      .wordlist-wrap {
        border: 1px solid #eee;
        border-radius: 4px;
        // min-height: 400px;
        // max-height: 720px;
        margin-top: 8px;
        font-size: 13px;
        .header {
          background-color: #f5f6f7;
          height: 40px;
          line-height: 40px;
          font-weight: 500;
          padding-left: 20px;
        }
        .content {
          height: 400px;
          overflow-y: auto;
          position: relative;
          padding: 12px 12px 0 12px;
          .text-item {
            display: inline-block;
            width: 600px;
            font-size: 12px;
            margin-bottom: 12px;
          }
        }
      }
    }
    padding-bottom: 24px;
  }

  .add-modal-body {
    .modal-content {
      width: 500px;
      .word-list-wrap {
        max-height: 500px;
        min-height: 20px;
        overflow: auto;
        .form-wrap {
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          margin-bottom: 12px;
          .form-header {
            height: 43px;
            background: rgba(0, 0, 0, 0.02);
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            padding: 0 16px;
            display: flex;
            align-items: center;
            .header-text {
              color: rgba(0, 0, 0, 0.85);
              font-size: 14px;
              margin-right: auto;
            }
            .center-line {
              height: 17.5px;
              border-right: 1px solid rgba(0, 0, 0, 0.2);
              margin: 0 15px;
              display: inline-block;
            }
            .del-icon {
              color: rgba(24, 144, 255, 1);
              font-size: 15px;
              cursor: pointer;
            }
          }
          .form-content {
            /deep/ .el-textarea__inner {
              border: none;
              height: 60px;
            }
          }
        }
      }

      /deep/ .add-icon {
        height: 32px;
        width: 100%;
        color: rgba(24, 144, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        margin-bottom: 24px;
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
      padding-bottom: 24px;
    }
  }
}
</style>
